import request from '@/utils/request'
import { orgId } from '@/common/base'

/**
 * 获取首页导航列表
 */
export function getNav() {
    return request({
        url: `/nav/${orgId}`,
        method: 'GET'
    })
}

/**
 * 获取首页banner图
 */
export function getBanners() {
    return request({
        url: `/banner/getBannerList?bannerTitle=home-banner&orgId=${orgId}`,
        method: 'GET'
    })
}

/**
 * 获取通知公告
 */
export function getNotice() {
    return request({
        url: `/notice/${orgId}`,
        method: 'GET'
    })
}

/**
 * 获取新闻图片
 */
export function getNewsPictures() {
    return request({
        url: `/banner/54193?offset=0&limit=5`,
        method: 'GET'
    })
}

/**
 * 获取要闻列表
 */
export function getNewsList() {
    return request({
        url: `/news/getNewsList?blockCode=main-news&orgId=${orgId}`,
        method: 'GET'
    })
}

/**
 * 获取区块1-6的内容
 */
export function getContent(num) {
    return request({
        url: `/news/getNewsList?blockCode=content-${num}&orgId=${orgId}`,
        method: 'GET'
    })
}

/**
 * 获取电子刊物
 */
export function getElectronicPublications() {
    return request({
        url: `/news/getNewsList?blockCode=electronic-publications&orgId=${orgId}`,
        method: 'GET'
    })
}

/**
 * 获取专题专栏
 */
export function getSpecials() {
    return request({
        url: `/news/getNewsList?blockCode=specials&orgId=${orgId}`,
        method: 'GET'
    })
}

/**
 * 下属公司
 */
export function getSubCompanies() {
    return request({
        url: `/news/getNewsList?blockCode=sub-companies&orgId=${orgId}&limitless=1`,
        method: 'GET'
    })
}
